if (!customElements.get("dashboard-banner-slider")) {
  class DashboardBannerSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll("[data-banner-slide]"));
      this.intervalMs = Number(this.dataset.interval) || 4000;
      this.index = this.slides.findIndex((slide) => slide.classList.contains("is-active"));
      if (this.index < 0) this.index = 0;
      this.timer = null;
      this.hovering = false;
      this.focusing = false;
      this.motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

      this.onEnter = () => {
        this.hovering = true;
        this.stop();
      };
      this.onLeave = () => {
        this.hovering = false;
        this.start();
      };
      this.onFocusIn = () => {
        this.focusing = true;
        this.stop();
      };
      this.onFocusOut = (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.focusing = false;
        this.start();
      };
      this.onMotionChange = () => {
        if (this.motionQuery.matches) {
          this.stop();
          return;
        }
        this.start();
      };

      this.addEventListener("mouseenter", this.onEnter);
      this.addEventListener("mouseleave", this.onLeave);
      this.addEventListener("focusin", this.onFocusIn);
      this.addEventListener("focusout", this.onFocusOut);
      this.motionQuery.addEventListener("change", this.onMotionChange);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener("mouseenter", this.onEnter);
      this.removeEventListener("mouseleave", this.onLeave);
      this.removeEventListener("focusin", this.onFocusIn);
      this.removeEventListener("focusout", this.onFocusOut);
      if (this.motionQuery) {
        this.motionQuery.removeEventListener("change", this.onMotionChange);
      }
    }

    start() {
      if (this.timer || this.hovering || this.focusing) return;
      if (!this.slides || this.slides.length < 2) return;
      if (this.motionQuery && this.motionQuery.matches) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), this.intervalMs);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      const previous = this.slides[this.index];
      this.index = nextIndex % this.slides.length;
      const current = this.slides[this.index];
      if (previous && previous !== current) this.setActive(previous, false);
      if (current) this.setActive(current, true);
    }

    setActive(slide, active) {
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", active ? "false" : "true");
      if (active) {
        slide.removeAttribute("inert");
      } else {
        slide.setAttribute("inert", "");
      }
    }
  }

  customElements.define("dashboard-banner-slider", DashboardBannerSlider);
}
